module.exports = __webpack_public_path__ + "assets/img/ic-coupon.3345cb55.svg";